import { Box, Typography } from '@mui/material'
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material'
import { passwordRequirements } from '../lib/password'

/** Live checklist of password rules; each item turns green once satisfied. */
export const PasswordRequirements = ({ password }: { password: string }) => (
  <Box sx={{ textAlign: 'left', px: 0.5 }}>
    {passwordRequirements.map(req => {
      const met = req.test(password)
      return (
        <Box key={req.label} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          {met ? (
            <CheckCircle sx={{ fontSize: 16, color: 'success.main' }} />
          ) : (
            <RadioButtonUnchecked sx={{ fontSize: 16, color: 'text.disabled' }} />
          )}
          <Typography variant="caption" color={met ? 'text.primary' : 'text.secondary'}>
            {req.label}
          </Typography>
        </Box>
      )
    })}
  </Box>
)
